export default __webpack_public_path__ + "static/small-business-accomplishment-2b-37e339ab7a4cf1ffc1318338bf93c1ec.webp";